import { all, fork } from "redux-saga/effects";

import authSaga from "@login/reducer/sagas";
import configSaga from "./config-store/sagas";
import deviceInfoSaga from "./devices/sagas";

import accountSaga from "app/modules/account-management/reducer/sagas";

import transferSaga from "app/modules/transfer/reducer/sagas";
import transfer247Saga from "app/modules/transfer/transfer-247/reducer/sagas";
import transferCashByCodeSaga from "app/modules/transfer/transfer-cash-by-code/reducer/sagas";
import transferForeignSaga from "app/modules/transfer/transfer-foreign/reducer/sagas";
import transferLocalSaga from "app/modules/transfer/transfer-local/reducer/sagas";
import transferStockSaga from "app/modules/transfer/transfer-stock/reducer/sagas";
import transferCharitySaga from "app/modules/transfer/transfer-charity/reducer/sagas";

import topUpSaga from "app/modules/top-up/reducer/sagas";
import billingSaga from "app/modules/billings/reducer/sagas";
import autoTopUpSaga from "app/modules/auto-top-up/reducer/sagas";
import autoBillingSaga from "app/modules/auto-billings/reducer/sagas";

import termDepositListSaga from "app/modules/term-deposit/list-term-deposit/reducer/sagas";
import termDepositOpenSaga from "app/modules/term-deposit/term-deposit-open/reducer/sagas";
import termDepositTopUpSaga from "app/modules/term-deposit/term-deposit-top-up/reducer/sagas";
import termDepositStatementSaga from "app/modules/term-deposit/term-deposit-statement/reducer/sagas";

import cardSaga from "app/modules/card-manager/reducer/sagas";
import paymentCardSaga from "app/modules/card-manager/payment-card/reducer/sagas";

import beneSaga from "app/modules/beneficiaries/reducer/sagas";
import statementSaga from "app/modules/account-management/statement/reducer/sagas";
import transHistorySaga from "app/modules/account-management/transaction-history/reducer/sagas";

import loyaltySaga from "app/modules/loyalty/reducer/sagas";
import changePasswordSaga from "app/modules/settings/change-password/reducer/sagas";

export function* rootSaga() {
  yield all([
    fork(deviceInfoSaga),
    fork(configSaga),
    fork(authSaga),
    fork(accountSaga),
    fork(transferSaga),
    fork(transfer247Saga),
    fork(transferCashByCodeSaga),
    fork(transferForeignSaga),
    fork(transferLocalSaga),
    fork(transferStockSaga),
    fork(transferCharitySaga),
    fork(topUpSaga),
    fork(billingSaga),
    fork(autoTopUpSaga),
    fork(autoBillingSaga),
    fork(termDepositListSaga),
    fork(termDepositOpenSaga),
    fork(termDepositTopUpSaga),
    fork(termDepositStatementSaga),
    fork(cardSaga),
    fork(paymentCardSaga),
    fork(beneSaga),
    fork(statementSaga),
    fork(transHistorySaga),
    fork(loyaltySaga),
    fork(changePasswordSaga)
  ]);
}
